// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteIcon_root__2ZN-3"};